import React, { memo } from "react";

//Loader Component for Displaying Loader
const Loader = () => {
  return (
    <div className="loader">
      <div className="loader-img"></div>
    </div>
  );
};

export default memo(Loader);